import { createFileRoute } from "@tanstack/react-router"
import { DataDeletionPage } from "@/routes/data-deletion"

export const Route = createFileRoute("/$lang/data-deletion")({
  component: DataDeletionPage,
})
